import { AxiosPromise, AxiosResponse } from 'axios';
import coreApiService from '../core/coreApi.service';
import { SESSION_REQUEST_HEADER_NAME } from '../../constants/main';

export const DEALERS_DIGITAL: string = 'digital-api/api/dealers';
const DEALERS_DEALER: string = 'dealer/api/v1/dealers/';
const DEALER_UPDATE_MOP: string = 'digital-api/api/update-mop-dealer/';

export const dealerApi = {
    getDealer: (dealerId: string): AxiosPromise => coreApiService.get(`${DEALERS_DIGITAL}/${dealerId}`),
    getAllDealers: (lat: string, lng: string): AxiosPromise =>
        coreApiService.get(`${DEALERS_DEALER}?latitude=${lat}&longitude=${lng}`),
    updateDeal: async (dealer_id: string, token: string): Promise<AxiosResponse<any>> => {
        const headers = { [SESSION_REQUEST_HEADER_NAME]: token || '' };
        await coreApiService.post(`${DEALER_UPDATE_MOP}${dealer_id}`, {}, headers);
        return coreApiService.patch(`${DEALERS_DEALER}deal/update`, { dealer_id }, headers);
    },
};
